import React from 'react'
import styled from 'styled-components'

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;

  div {
    width: 0.5rem;
    height: 0.5rem;
    background-color: #fff;
    border-radius: 50%;
    margin: 0 4px;
    opacity: 0.2;
    animation: dotFlashing 1s infinite linear alternate;
  }

  div:nth-child(2) {
    animation-delay: 0.2s;
  }

  div:nth-child(3) {
    animation-delay: 0.4s;
  }

  @keyframes dotFlashing {
    0%,
    100% {
      opacity: 0.2;
    }
    50% {
      opacity: 1;
    }
  }
`

function ThreeDotsLoader() {
  return (
    <LoaderContainer>
      <div />
      <div />
      <div />
    </LoaderContainer>
  )
}

export default ThreeDotsLoader
